// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2B1gs","title":"AfterBackImages_title__12FHU","images":"AfterBackImages_images__1BOt0"};